// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseCircleTwoToneSvg from "@fishx/icons-svg/es/asn/PauseCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleTwoToneSvg
  }));
};

PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
export default React.forwardRef(PauseCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PauseCircleTwoTone.js
// module id = 3762
// module chunks = 0